import InputSelect from "../InputSelect";
import { getCountries } from "../../api/SelectApi";
import { tr } from "../../i18n";

const SelectCountry = (props) => {
  const data = {
    name: props.name || "country_id",
    placeholder: tr("shared:select_country"),
    rules: props.rules,
    className: props.className,
    defaultValue: props.defaultValue,
  };

  async function handleData(search = "") {
    const result = await getCountries(search);
    return result.data.map((d) => ({
      label: d.text,
      value: d.id,
    }));
  }

  return (
    <InputSelect props={props} data={data} handleOnLoadData={handleData} />
  );
};

export default SelectCountry;
